import { dataToExecData, ExecArgBase } from '../ExecArgBase.js';
/**
 * @category Contract Exec Arguments
 */
export default class ExecArgDepositTokens extends ExecArgBase {
    static fromJSON(params) {
        return new ExecArgDepositTokens(params);
    }
    toData() {
        return {};
    }
    toExecData() {
        return dataToExecData('deposit_tokens', this.toData());
    }
}
